__webpack_require__.p = "/AI-Powered-Smart-PDF-Chatbot-FastAPI-React-OpenAI/";